export default class CookiesService {
  constructor() {
    /**@type {String} Local storage key string for accepted cookies */
    this.cookiesAccepted = "cookiesAccepted";
  }

  /**
   * Checking local storage if user has accepted cookies before
   */
  getCookiesStatus() {
    return localStorage.getItem(this.cookiesAccepted);
  }
  
  /**
   * Save to local storage the cookies status
   */
  setCookiesStatus(value) {
    localStorage.setItem(this.cookiesAccepted, value);
  }
}
